var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"input-full"},[_c('div',[_c('div',{staticClass:"card-content padding"},[_c('div',{staticClass:"form-container"},[_c('form',[_c('DxForm',{attrs:{"label-location":"left","form-data":_vm.formData}},[_c('DxItem',{attrs:{"data-field":"orderNumber","editor-type":"dxTextBox","editor-options":{
                  disabled: false,
                  width: '100%',
                }}},[_c('DxLabel',{attrs:{"visible":false,"text":"prueba"}})],1)],1)],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }